import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=141dd4e8&"
import script from "./RolePermissions.js?vue&type=script&lang=js&"
export * from "./RolePermissions.js?vue&type=script&lang=js&"
import style0 from "./RolePermissions.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports